/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { ProductDropdownResponseDto } from '../model/productDropdownResponseDto';
import { ProductPaginationResponseDto } from '../model/productPaginationResponseDto';
import { ProductPurchasingDropdownResponseDto } from '../model/productPurchasingDropdownResponseDto';
import { ProductRequestDto } from '../model/productRequestDto';
import { ProductResponseDto } from '../model/productResponseDto';
import { ValidationError } from '../model/validationError';

export enum productsBranchCostAppraisalGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsCostAppraisalGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsPublicGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productsPurchasingDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class ProductsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public productsBranchCostAppraisalGet$(productCategoryId: string, branchId: string, costAppraisalId?: string, name?: string, language?: string): Observable<Array<ProductResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/products/branch-cost-appraisal`, { productCategoryId, branchId, costAppraisalId, name, language });
  }
  /**
   * [Authorize] type: http
   */
  public productsCostAppraisalGet$(productCategoryId: string, costAppraisalId?: string, name?: string, language?: string): Observable<Array<ProductResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/products/cost-appraisal`, { productCategoryId, costAppraisalId, name, language });
  }
  /**
   * [Authorize] type: http
   */
  public productsDropdownGet$(page?: number, limit?: number, name?: string, productCategoryIds?: Array<string>, language?: string, isActive?: boolean, sort?: string): Observable<Array<ProductDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/products/dropdown`, { page, limit, name, productCategoryIds, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public productsGet$(page?: number, limit?: number, name?: string, productCategoryIds?: Array<string>, language?: string, isActive?: boolean, sort?: string): Observable<ProductPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/products`, { page, limit, name, productCategoryIds, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public productsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/products/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productsIdGet$(id: string, language?: string): Observable<ProductResponseDto> {
    return this.api.get(`${apiBaseUrl()}/products/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public productsIdPut$(id: string, body: ProductRequestDto): Observable<ProductResponseDto> {
    return this.api.put(`${apiBaseUrl()}/products/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productsIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/products/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productsPost$(body: ProductRequestDto): Observable<ProductResponseDto> {
    return this.api.post(`${apiBaseUrl()}/products`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productsPublicGet$(productCategoryId?: string, language?: string, sort?: string): Observable<Array<ProductResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/products/public`, { productCategoryId, language, sort });
  }
  /**
   * [Authorize] type: http
   */
  public productsPurchasingDropdownGet$(branchId: string, memberId?: string, bulkSaleBranchId?: string, productCategoryId?: string, language?: string): Observable<Array<ProductPurchasingDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/products/purchasing/dropdown`, { branchId, memberId, bulkSaleBranchId, productCategoryId, language });
  }
}
